const ROLES = {
  RESIDENT: 1,
  ADMIN: 2,
  PRESIDENT: 3,
  SUB_ADMIN: 4,
  SUPER_ADMIN: 5
};

export default ROLES;
